import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.css";
import MainPage from "./components/MainPage";
import GrouppyPage from "./components/demos/GrouppyPage";
import LockdownCYPage from "./components/demos/LockdownCYPage";
import SudokuPage from "./components/demos/SudokuPage";
import theme from "./config/theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/demos/sudoku" element={<SudokuPage />} />
          <Route path="/demos/lockdowncy" element={<LockdownCYPage />} />
          <Route path="/demos/grouppy" element={<GrouppyPage />} />
          <Route path="*" element={<MainPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
